// Custom validator that accepts both String and Number
const stringOrNumber = (value) => {
  if (typeof value === 'undefined') return true
  return typeof value === 'string' || typeof value === 'number'
}

const itemSchema = [
  {
    qty: Number,
    productId: stringOrNumber,
    parentId: stringOrNumber,
    // Optional fields - not required for validation
    scope: (value) => true,
    price: (value) => true,
    custombasket: (value) => true,
    options: (value) => true,
    thumbnail: (value) => true,
    name: (value) => true
  }
]
export default itemSchema
